/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADVANCED SECTION - COMMENTS COUNTER : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '& .productmanagerlink': {
      textDecoration: 'underline', 
      fontWeight: 600, 
      cursor: 'pointer'
    }
  },
  commentscounter: {
    '& .warningicon': {
      flex: 'none',
      '& path': {
        fill: '#7E92B8'
      }
    },
    '& .name-question-circle':{
      color: '#7E92B8'
    },
    '& .codepiece': {
      marginBottom: '10px',
      '& h3.title': {
        fontWeight: 400
      }
    },
    '& .countericons .icon': {
      height: '70px',
      width: '70px',
      border: '2px solid #CCD1E6',
      borderRadius: '12px',
      padding: '18px',
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': {
        border: '2px solid #97A1CA'
      },
      '&.selected-true': {
        border: '2px solid #3257EC'
      },
      '&.none': {
        background: '#F7F8FC'
      }
    },
    '& .previewconfig': {
      '& .content': {
        fontWeight: 600,
        height: '100px',
        '& h3': {
          fontSize: '24px',
          fontFamily: '"Source Serif Pro",serif'
        },
        '& .commentstext': {
          display: 'flex',
          gap: '8px',
          '&.icon-first': {
            flexDirection: 'row'
          },
          '&.text-first': {
            flexDirection: 'row-reverse'
          }
        },
        '& .count': {
          background: '#F7F8FC',
          borderRadius: '24px',
          padding: '4px 8px'
        }
      }
    }
  }
});
